import { EMPTY_PHONE } from "@/utils/customerProfile.js";

export function createEmptyAdminProfile() {
    return {
        username: "",
        firstName: "",
        lastName: "",
        email: "",
        photoId: null,
        phones: []
    };
}

export function normalizeAdminPhones(phones) {
    if (!phones?.length) {
        return [{ ...EMPTY_PHONE }];
    }
    return phones.map((phone) => ({
        phoneNumber: phone.phoneNumber || "",
        label: phone.label || ""
    }));
}

export function adminDisplayName(profile) {
    if (!profile) {
        return "";
    }
    return `${profile.firstName || ""} ${profile.lastName || ""}`.trim();
}

export function buildAdminProfilePayload(profile) {
    const phones = (profile.phones || [])
        .map((phone) => ({
            phoneNumber: phone.phoneNumber.trim(),
            label: phone.label.trim() || undefined
        }))
        .filter((phone) => phone.phoneNumber);

    return {
        firstName: profile.firstName,
        lastName: profile.lastName,
        email: profile.email?.trim() || null,
        photoId: profile.photoId || undefined,
        phones
    };
}
